import { onMounted, createApp } from "vue";
import { useRouter } from "vue-router";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export const useMap = (
  mapElementId,
  latitude,
  longitude,
  popupComponent,
  iconPath,
  data,
) => {
  let map;
  const router = useRouter();
  function goToDetails(id) {
    router.push({ name: "PropertyDetails", params: { id } });
  }
  onMounted(() => {
    try {
      map = L.map(mapElementId).setView([latitude, longitude], 13);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attributionControl: false,
      }).addTo(map);

      data.forEach((location) => {
        const popupContainer = document.createElement("div");
        const app = createApp(popupComponent, { data: location });
        app.mount(popupContainer);

        const icon = L.icon({
          iconUrl: iconPath,
          iconSize: [101, 82],
          iconAnchor: [50, 20],
          popupAnchor: [0, -22],
        });

        const marker = L.marker([location?.latitude, location?.longitude], {
          icon,
        }).addTo(map);

        marker.on("mouseover", () => {
          marker.bindPopup(popupContainer).openPopup();
        });

        marker.on("mouseout", () => {
          marker.closePopup();
        });

        marker.on("click", () => {
          goToDetails(location.id);
        });
      });
    } catch (error) {
      console.error("Error initializing map:", error);
    }
  });

  const invalidateSize = () => {
    if (map) {
      map.invalidateSize();
    }
  };

  return { map, invalidateSize };
};
